module.exports = __webpack_public_path__ + "static/media/rpsale_question.a1150397.mp3";